// Warp gate lines (GDD 01 §3): one 1 px line per connection.
import type { MapResponse } from '@stars-and-ships/api-types';
import { Graphics } from 'pixi.js';
import { MAP_COLORS } from '../../theme';

export function gatesLayer(map: MapResponse): Graphics {
  const byId = new Map(map.systems.map((s) => [s.id, s]));
  const gates = new Graphics();
  for (const link of map.warpConnections) {
    const a = byId.get(link.a);
    const b = byId.get(link.b);
    if (a && b) gates.moveTo(a.x, a.y).lineTo(b.x, b.y);
  }
  gates.stroke({ width: 1, color: MAP_COLORS.gate, pixelLine: true });
  return gates;
}
